export default __webpack_public_path__ + "static/media/pending.848a9fb8.svg";